import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useI18n } from '../content/i18n';
import './SolutionSection.css';

gsap.registerPlugin(ScrollTrigger);

const SolutionSection = () => {
  const { t, isKo } = useI18n();
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const problemRef = useRef(null);
  const solutionRef = useRef(null);
  const iconRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // 타이틀 애니메이션
      gsap.fromTo(
        titleRef.current,
        { 
          opacity: 0, 
          y: 30,
          scale: 0.9
        },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.8,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 75%',
            end: 'top 60%',
            scrub: 1,
          },
        }
      );

      // 문제 제기 애니메이션
      gsap.fromTo(
        problemRef.current,
        { 
          opacity: 0, 
          y: 30
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 70%',
            end: 'top 55%',
            scrub: 1,
          },
        }
      );

      // 해결책 애니메이션 (문제 제기보다 조금 늦게)
      gsap.fromTo(
        solutionRef.current,
        { 
          opacity: 0, 
          y: 50,
          scale: 0.95
        },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 60%',
            end: 'top 40%',
            scrub: 1,
            onEnter: () => {
              // 스크롤 트리거가 활성화되면 아이콘 애니메이션 시작
              if (iconRef.current) {
                iconRef.current.style.animation = 'none';
                setTimeout(() => {
                  iconRef.current.style.animation = 'iconDrop 1.2s cubic-bezier(0.34, 1.56, 0.64, 1) forwards';
                }, 10);
              }
            }
          },
        }
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section className="solution-section" ref={sectionRef}>
      <div className="solution-content container">
        <h3 className="solution-title" ref={titleRef}>
          {isKo ? (
            <>
              <span className="gradient-text">좋아하는 콘텐츠</span>
              <span className="white-text">와</span>
              <span className="gradient-text">미믹킹</span>
            </>
          ) : (
            <span className="gradient-text">{t.solution.title}</span>
          )}
        </h3>
        <p className="solution-problem" ref={problemRef}>
          {t.solution.problem}
        </p>
        <div className="solution-wrapper" ref={solutionRef}>
          <img 
            ref={iconRef}
            src="/resource/new_AppIcon.png" 
            alt={t.solution.appIconAlt}
            className="app-icon-drop" 
          />
          <h2 className="solution-text">
            <span className="mimic-brand">{t.common.brand}</span>
            {isKo ? <span className="mimic-korean">{t.common.brandKo}</span> : null}
            {t.solution.headlineAfterBrand}
          </h2>
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;
